import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AbilityContext } from '../context/AbilityContext'
import { buildAbilityFor } from './acl'
import { useAuth } from '../hooks/useAuth'
// import NotAuthorized from '../pages/not-authorized'
import Spinner from '../Components/MainScreens/Spinner/Spinner'

const AclGuard = ({ children, aclAbilities }) => {
  const { user } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  if (!user) return <Spinner />

  const ability = buildAbilityFor(user.role, user.permissions || {})

  const canAccess = ability.can(aclAbilities.action, aclAbilities.subject)

  // if (!canAccess) {
  //   return <>Not Authorized</> // <NotAuthorized />
  // }

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  )
}

export default AclGuard
